export default __webpack_public_path__ + "static/media/leaf1.1c704cd3.png";